import { t } from 'i18next';
import { noop } from 'lodash-es';
import { parse } from 'query-string';
import { Dialog } from 'rc-ui-lib';
import { LanguageType } from '../../../types/language';
import { iOS } from '../env';
import { clearLocalStorage } from '../localStorage';
import { DeviceInfo, NativeApi, Platform } from './interface';
import { getDevLang } from './utils';

export type MyLinkDeviceInfo = DeviceInfo & {
  phone?: string;
  platform?: 'iOS' | 'Android';
  deviceId?: string;
};

// sc(简体中文）、tc（繁体中文）、en（英文）
enum MyLinkLang {
  SimpleChinese = 'sc',
  TraditionalChinese = 'tc',
  English = 'en',
}

export const langReverseMap: {
  [key in LanguageType]: MyLinkLang;
} = {
  cn: MyLinkLang.SimpleChinese,
  zh: MyLinkLang.TraditionalChinese,
  en: MyLinkLang.English,
};

const langMap: {
  [key in MyLinkLang]: LanguageType;
} = {
  [MyLinkLang.SimpleChinese]: 'cn',
  [MyLinkLang.TraditionalChinese]: 'zh',
  [MyLinkLang.English]: 'en',
};

export const mylink: NativeApi = {
  platformInfo: {},
  name: Platform.MyLink,
  token: '',
  utils: {
    CMCLOCALKEY: 'MYLINK-CMC',
  },
  async init(options = {}) {
    const { initLangCallBack = noop } = options;

    const systemInfo = await this.getSystemInfo?.();
    this.saveInfo?.(systemInfo);
    const lang = await this.getLanguage?.();
    initLangCallBack(lang);
  },
  setToken(token: string) {
    this.token = token;
  },
  async getToken() {
    if (!this.token) {
      this.token = '';
    }
    return this.token;
  },
  getRequestHeader() {
    return {
      thirdPartnerCode: 'MyLink',
    };
  },
  async getLanguage() {
    const params = parse(location.search);
    const lang = langMap[params.lang as MyLinkLang] || getDevLang();
    return lang;
  },

  closeWindow(objParam: any = '') {
    clearLocalStorage(this.utils?.CMCLOCALKEY);
    const obj = JSON.stringify(objParam);
    if (iOS()) {
      (window as any).webkit &&
        (window as any).webkit.messageHandlers &&
        (window as any).webkit.messageHandlers.closeWebview &&
        (window as any).webkit.messageHandlers.closeWebview.postMessage(obj);
    } else {
      (window as any).HkAndroid && (window as any).HkAndroid.closeWebview();
    }
  },
  reLogin() {
    Dialog.confirm({
      message: t('credit.expired_info'),
      showCancelButton: false,
      closeable: false,
      confirmButtonText: t<string>('common_confirm'),
      onConfirm: () => {
        this.closeWindow();
      },
    });
    return '';
  },
  getSystemInfo() {
    let respResolved: (value: MyLinkDeviceInfo | Promise<MyLinkDeviceInfo>) => void = noop;
    const respPromise = new Promise<MyLinkDeviceInfo>((resolve) => {
      respResolved = resolve;
    });
    const callback = (res: MyLinkDeviceInfo) => {
      respResolved(res);
      window.getSystemInfoCb = null;
    };
    window.getSystemInfoCb = callback;
    const obj = JSON.stringify({ callbackName: 'getSystemInfoCb' });
    if (iOS()) {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.getDeviceInfoWithCallback
      ) {
        window.webkit.messageHandlers.getDeviceInfoWithCallback.postMessage(obj);
      } else {
        respResolved({
          os: 'iOS',
          deviceId: '',
          appVersion: null,
        });
      }
    } else if (window.HkAndroid && window.HkAndroid.getDeviceInfoWithCallback) {
      window.HkAndroid.getDeviceInfoWithCallback(obj);
    } else {
      respResolved({
        os: 'Android',
        deviceId: '',
        appVersion: null,
      });
    }
    return respPromise;
  },

  saveInfo(info) {
    this.platformInfo = Object.assign(this.platformInfo, info);
  },
  getStatusBarHeight() {
    return Number.parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--sat'),
      10
    );
  },
  gotoWhatsApp: () => {
    location.href = 'https://wa.me/85263692338';
  },
  getDeviceId() {
    return this.platformInfo?.deviceId || '';
  },
};
